import * as React from 'react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

/**
 * A number input that says what it is measured in.
 *
 * Every figure on a settlement is a euro amount, a cubic metre or a kWh,
 * and which one it is decides whether it is plausible. Without the unit the
 * reader has to infer it from the column it happens to sit in.
 */
export const UnitInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & { unit?: string }
>(({ unit, className, ...props }, ref) => {
  if (!unit) return <Input ref={ref} className={className} {...props} />

  return (
    <div className={cn('relative', className)}>
      <Input ref={ref} className="pr-14" {...props} />
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
        {unit}
      </span>
    </div>
  )
})
UnitInput.displayName = 'UnitInput'
